// 언어 코드는 여기 한 곳에서만 해석한다.
// 앱 안 언어값: ko / en / jp (문구 파일 이름과 같다). 화면(html lang) 언어값: ko / en / ja.
const APP_LANGS = ["ko", "en", "jp"]
const ALIASES = { kr: "ko", kor: "ko", eng: "en", ja: "jp", jpn: "jp" }

// 브라우저 언어(ja-JP), 주소의 ?lang=ja, 저장된 값 등을 앱 언어값으로 바꾼다. 모르는 값이면 null.
export function normalizeLang(value) {
  const code = String(value || "").trim().toLowerCase().split(/[-_]/)[0]
  const lang = ALIASES[code] || code
  return APP_LANGS.includes(lang) ? lang : null
}

export function domLang(lang) {
  const normalized = normalizeLang(lang) || "ko"
  return normalized === "jp" ? "ja" : normalized
}

// 서버가 {"kr":"…","en":"…","jp":"…"} 모양(글자로 저장된 것 포함)으로 주는 이름을 앱 언어에 맞춰 고른다.
// 그 언어 이름이 비어 있으면 한국어 → 영어 → 일본어 순으로 있는 것을 쓴다.
export function localizedText(value, lang) {
  if (value === null || value === undefined) return ""
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value)
      return parsed && typeof parsed === "object" ? localizedText(parsed, lang) : value
    } catch (error) {
      return value
    }
  }
  if (typeof value === "object") {
    const key = normalizeLang(lang) === "ko" ? "kr" : normalizeLang(lang)
    return value[key] || value.kr || value.ko || value.en || value.jp || ""
  }
  return String(value)
}

export function applyDocumentLang(lang) {
  if (typeof document !== "undefined") document.documentElement.lang = domLang(lang)
}
